import React, { useState, useEffect } from 'react';
import {
  Button,
  FormGroup,
  Label,
  Input,
  Col,
  Row,
  ModalBody,
} from 'reactstrap'
import withReactContent from 'sweetalert2-react-content'
import rotas from 'services/rotas'
import rest from 'lib/rest'
import Swal from 'sweetalert2'
import Loading from 'lib/loading'
import useForm from 'lib/useForm'

const formSwal = withReactContent(Swal)

const DuplicaKit = ({fechaModal, listaProdutos}) => {

  const inicialForm = {
    lojas: []
  }

  const [form, , setForm, , , , onChangeArray] = useForm(inicialForm)
  const [loading, setLoading]     = useState(true)
  const [lojas, setLojas]         = useState([])

  const lista = () => {
    try{
    const retorno = rest.get(rotas.lojas)
      retorno.then(ret => {
        if ((ret.success) && (ret.success === 'S') && (ret.lista !== '')){
          for (let i = 0; i < ret.lista.length; i++) {
            let id = ret.lista[i].filial_id
            inicialForm.lojas[id] = 'S'
          }
          
          setForm(inicialForm)
          setLojas(ret.lista)
        }
        setLoading(false)
      })
      return (true)
    }catch(err){
      setLoading(false)
      return (false)
    }
  }

  const listaCheckbox = lojas.map((loja, index) => {
    return (
      <Row key={loja.filial_id+index}>
      <Col className="p-0" md="12">
        <FormGroup className="m-6" check>
          <Label style={{paddingLeft: '30px'}} check>
            <Input
              type      = "checkbox"
              id        = {"lojasItem" + loja.filial_id}
              key       = {"lojasItem" + loja.filial_id}
              name      = "fidelidade"
              label     = {loja.nome}
              checked   = {form.lojas[loja.filial_id] === 'S' ? true : false}
              onChange  = {onChangeArray(loja.filial_id, 'lojas')}
            />
            <span className="form-check-sign" />{loja.cnpj +' - '+loja.fantasia}
          </Label>
        </FormGroup>
      </Col>
      </Row>
    )
  })

  const submitDuplicaKit = () => {

    let select = false
    form.lojas.forEach((loja) => { if (loja === 'S') { select = true } })

    if (!select) {
      formSwal.fire('Loja não selecionada!', 'Por favor, selecione pelo menos uma loja para replicar a lista de produtos.','warning')
      return false
    }

    let dados = {
      'listaProdutos': listaProdutos,
      'listaLojas': form,
    }

    formSwal.queue([{
      title: 'Deseja replicar a lista de produtos para as lojas selecionadas ?',
      confirmButtonText: 'Replicar',
      showCancelButton: true,
      text:'Essas informações serão salvas no banco',
      showLoaderOnConfirm: true,
      cancelButtonColor: '#d33',
      preConfirm: () => {
        const url = rotas.Kit+'replicarProdutosKit.php'

        return rest.post(url, dados)
        .then(ret => {
          if (ret.success && ret.success === 'S') {
            formSwal.fire('Salvo! Lista replicada para as lojas.',
                      'Obs.: Apenas replica os produtos inexistentes no kit das outras lojas.',
                      'success')
            fechaModal()
          }else{
            formSwal.fire('Erro!',
                          ret.msg,
                          'error')
          }
        })
      }
    }])
  }

  useEffect(() => {
    lista()
  },[]) // eslint-disable-line react-hooks/exhaustive-deps

  if (loading) {
    return (
      <ModalBody className ="loadingBody">
        <Loading tipo='componente'/>
      </ModalBody>
    )
  }
  return (
    <>
      <ModalBody className="pb-0">
        <FormGroup className="formCadastro">
          <Col md='12'>
            {listaCheckbox}
          </Col>
          <Col className="text-center p-3">
            <Button type="submit" className="mb-0 mt-0" color="success" size="md"onClick={() => submitDuplicaKit()} >
              Replicar
            </Button>
            <Button type="button" className="mb-0 mt-0" color="default" size="md" onClick={() => fechaModal()}>
              Fechar
            </Button>
          </Col>
        </FormGroup>
      </ModalBody>
    </>
  )
  
}

export default DuplicaKit
